import { cloneElement, useRef, useState } from 'react'
import { Tooltip } from 'reactstrap'
import type { HintProps } from '../../types/shared'
import { useAppSelector } from '../../redux/hooks'
import { getContainerProp } from '../../Webcomponent/utils/common'
import useMediaQuery from '../../utils/useMediaQuery'

const Hint = ({ label, children, placement = 'top', forceOpen = false }: HintProps) => {
  const [tooltipOpen, setTooltipOpen] = useState(false)
  const targetRef = useRef<HTMLElement | null>(null)

  const { dropdownContainer } = useAppSelector((state) => state.templateCustomizer)

  // Tooltips are a mouse affordance. On touch devices a tap opens the tooltip
  // but no mouseleave/blur fires, so it stays stuck on screen (e.g. the sidebar
  // icon's label lingering after the menu closes). Only render on hover-capable
  // devices, unless explicitly forced open.
  const canHover = useMediaQuery('(hover: hover)')

  const toggle = () => setTooltipOpen((prev) => !prev)
  const isOpen = forceOpen || tooltipOpen

  const childWithProps = cloneElement(children, {
    ref: (node: HTMLElement) => {
      targetRef.current = node
    },
  })

  return (
    <>
      {childWithProps}
      {targetRef.current && (forceOpen || canHover) && (
        <Tooltip
          {...(getContainerProp(dropdownContainer) || {})}
          placement={placement}
          isOpen={isOpen}
          target={targetRef.current} // ✅ element, not ID
          toggle={toggle}
        >
          {label}
        </Tooltip>
      )}
    </>
  )
}

export default Hint
